@if (categoryOptions().length > 1) {
  <div data-test="invoice-list-category-filter-container" ngbDropdown placement="bottom-right top-right">
    <button
      [attr.id]="buttonId()"
      class="btn btn-md btn-primary--blue w-100"
      style="padding: 6px 16px"
      ngbDropdownToggle
      #buttonElement
      role="combobox"
      [attr.aria-label]="'interactive-invoices.product' | translate"
      aria-autocomplete="list"
      [attr.aria-owns]="dropdownId()"
      [attr.aria-controls]="dropdownId()"
      [attr.aria-activedescendant]="selectedCategoryIndex() === null ? null : dropdownId() + '_option_' + selectedCategoryIndex()"
    >
      <span aria-hidden="true">{{ 'interactive-invoices.product' | translate }}: </span>
      <span class="ml-1">{{
        selectedCategory()
          ? (selectedCategory() | translateCategory: isFernwaermeTariffClass(selectedCategory()))
          : ('interactive-invoices.allCategoriesFilter' | translate)
      }}</span>
      <i class="ml-1 fas fa-chevron-down transition-all" aria-hidden="true" [ngClass]="{ 'rotate-x-180': !isCollapsed() }"></i>
    </button>

    <div ngbDropdownMenu [attr.id]="dropdownId()" role="listbox">
      @for (category of categoryOptions(); track $index) {
        <button
          [ngClass]="{ 'dropdown-item-checked': category === selectedCategory() }"
          [attr.aria-selected]="category === selectedCategory() ? 'true' : 'false'"
          [attr.data-test]="'invoice-list-category-filter-dropdown-item-' + (category?.toLowerCase() || 'all')"
          [attr.id]="dropdownId() + '_option_' + $index"
          (click)="selectCategory(category, $index)"
          role="option"
          ngbDropdownItem
        >
          @if (isFernwaermeTariffClass(category)) {
            <span>
              {{ category | translateCategory: true }}
            </span>
          } @else {
            <span>
              {{ category ? (category | translateCategory) : ('interactive-invoices.allCategoriesFilter' | translate) }}
            </span>
          }
        </button>
      }
    </div>
  </div>
}
